import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { usersData } from './slice'
import { userAPI } from '../../api'
import { RequestUtils } from 'utils'

function* getData({ payload: { id, params = {} } }) {
  try {
    let requestParams = {
      includes: ['avatar', 'studentProfile', 'fullEmployerProfile', 'subscription'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(userAPI.getUser, id, requestParams)

    const { data } = response

    yield put(usersData.getDataSuccess(data))
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(usersData.getDataError(message))
  }
}

function* watchGetData() {
  yield takeEvery(usersData.getData, getData)
}

export function* dataSaga() {
  yield all([fork(watchGetData)])
}
